import React from 'react';
import Sidebar from '../components/Sidebar';
import DashboardNavbar from '../components/DashboardNavbar';
import GlobalExchangeTable from '../components/GlobalExchangeTable';

const GlobalExchange = () => {
  return (
    <div className="d-flex entire-bg-color">
      <Sidebar />

      <div className="flex-grow-1">
        <DashboardNavbar />
        <div style={{ marginTop: '70px' }}></div>

        <GlobalExchangeTable />
      </div>
    </div>
  );
};

export default GlobalExchange;